import { render, staticRenderFns } from "./RemuneracaoAgendaGarantiaMinimaRightNavBar.vue?vue&type=template&id=1d01bfd2"
import script from "./RemuneracaoAgendaGarantiaMinimaRightNavBar.vue?vue&type=script&lang=ts"
export * from "./RemuneracaoAgendaGarantiaMinimaRightNavBar.vue?vue&type=script&lang=ts"
import style0 from "./RemuneracaoAgendaGarantiaMinimaRightNavBar.vue?vue&type=style&index=0&id=1d01bfd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports